import { defineComponent } from "vue";

/**
 * 渲染 `ReportCenter` SVG 图标。
 *
 * @remarks
 * Vue 透传属性（如 `class`、`style`、`role`、`aria-label`、`width`、`height` 和 `fill`）会应用到根 `<svg>` 元素。
 */
export const ReportCenter = defineComponent({
	name: "ReportCenter",
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
				<path d="M562.625 163.25V62H461.375v101.25H62v101.25h50.625v506.25H427.625L230.75 922.625l33.75 39.375 241.875-196.875 241.875 196.875 33.75-39.375L590.75 765.125h320.625V258.875h50.625V163.25H562.625z m298.125 551.25H163.25v-450h697.5v450zM309.5 613.25V461.375h151.875c0-73.125-61.875-129.375-135-129.375-73.125 0-135 61.875-135 135 5.625 73.125 45 146.25 118.125 146.25z m50.625 50.625c78.75 0 151.875-78.75 151.875-151.875H360.125v151.875z m399.375-303.75H613.25v50.625H765.125v-50.625z m0 101.25H613.25V512H765.125v-50.625z m0 101.25H613.25v50.625H765.125v-50.625z" />
			</svg>
		);
	},
});

export default ReportCenter;
